import { BannerInterface } from 'src/app/interfaces/banner.interface';
import { DeviceDetectorService } from 'ngx-device-detector';

import { ChangeDetectorRef } from '@angular/core';

import { WindowRefService } from '@shared/window-ref';

import { BaseComponent } from '../base.component';

/**
 *  Abstract class
 *  @author Livescore <jsmith@example.com>
 *  @copyright 2020 livescore
 */

export abstract class BannerBase extends BaseComponent {
    public bannerPositionId: number | null = null;

    public banner: BannerInterface | null = null;

    public constructor(
        public deviceService: DeviceDetectorService,
        protected ref: ChangeDetectorRef,
        protected win: WindowRefService
    ) {
        super();
    }

    public setBanner(banner: BannerInterface | null): void {
        this.banner = banner;

        this.ref.markForCheck();
        this.impression();
    }

    public impression(): void {
        if (this.banner) {
            this.win.nativeWindow.dataLayer.push({
                event: 'banner_impression_web',
                banner_id: this.banner?.id,
                banner_name: this.banner?.utm_medium ?? this.banner?.altText ?? 'N/A',
            });
        }
    }

    public click(): void {
        this.win.nativeWindow.dataLayer.push({
            event: 'click_banner_web',
            banner_id: this.banner?.id,
            banner_name: this.banner?.utm_medium ?? this.banner?.altText ?? 'N/A',
        });
    }

    public utm(url: string): string {
        let q = '&';

        if (!url.includes('?')) {
            q = '?';
        }

        if (this.banner!.utm_medium !== null) {
            q += `utm_medium=${this.banner!.utm_medium}&`;
        }
        if (this.banner!.utm_source !== null) {
            q += `utm_source=${this.banner!.utm_source}&`;
        }
        return q.substring(0, q.length - 1);
    }
}
